/* eslint-disable */
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Range Number input
 * Update label with value
 */

// Import dependencies
import { initialiser } from '../utilitybelt';

var RangeSlider = function RangeSlider(config) {
  var _this = this;

  _classCallCheck(this, RangeSlider);

  this.init = function () {
    if (!_this.input) return;
    _this.bindEvents();

    if (_this.updateBg && _this.bg) _this.updateBackground(); // update background on first load
  };

  this.bindEvents = function () {
    if (_this.label) {
      _this.input.addEventListener('input', _this.updateLabel);
      _this.input.addEventListener('change', _this.updateLabel); // for ie
    }

    if (_this.updateBg && _this.bg) {
      _this.input.addEventListener('input', _this.updateBackground);
      _this.input.addEventListener('change', _this.updateBackground); // for ie
    }
  };

  this.updateBackground = function () {
    var max = _this.input.getAttribute('max') || 100;
    _this.bg.style.backgroundSize = 100 * (_this.input.value / max) + '% 100%';
  };

  this.updateLabel = function () {
    var getLabel = function getLabel(type, input) {
      var value = input.value;

      if (type !== 'ratio') return value;

      var max = input.getAttribute('max') || 100;
      return value + '/' + (max - value);
    };

    var label = getLabel(_this.labelType, _this.input);

    _this.label.innerHTML = label;
  };

  this.input = config.el;
  var labelId = this.input && this.input.getAttribute('data-label-id');
  this.label = document.getElementById(labelId);
  this.labelType = this.input && this.input.getAttribute('data-label-type');
  this.updateBg = this.input.getAttribute('data-update-bg') || false;
  this.bg = document.getElementById(this.updateBg);
};

export default function(settings) {
  return initialiser(settings, RangeSlider);
} 